module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00323.bde8b203.jpg";